export const actions = {
    START_FETCHING_SETTINGS_CHALLENGE_TYPES: 'START_FETCHING_SETTINGS_CHALLENGE_TYPES',
    FETCHING_SUCCESSFUL_SETTINGS_CHALLENGE_TYPES: 'FETCHING_SUCCESSFUL_SETTINGS_CHALLENGE_TYPES',
    FETCHING_FAILED_SETTINGS_CHALLENGE_TYPES: 'FETCHING_FAILED_SETTINGS_CHALLENGE_TYPES',
    START_UPDATING_SETTINGS_CHALLENGE_TYPE_ICON: 'START_UPDATING_SETTINGS_CHALLENGE_TYPE_ICON',
    SETTINGS_CHALLENGE_TYPE_ICON_UPDATED: 'SETTINGS_CHALLENGE_TYPE_ICON_UPDATED',
    SETTINGS_CHALLENGE_TYPE_ICON_FAILED: 'SETTINGS_CHALLENGE_TYPE_ICON_FAILED'
};

export const initialState = {
    listingFetching: false,
    listingResponse: {
        data: [],
        meta: {},
        included: []
    },
    listingError: []
};

export default (state = initialState, { type, response }) => {
    switch (type) {
        case actions.START_FETCHING_SETTINGS_CHALLENGE_TYPES: {
            return {
                ...state,
                listingFetching: true
            };
        }
        case actions.FETCHING_SUCCESSFUL_SETTINGS_CHALLENGE_TYPES: {
            return {
                ...state,
                listingFetching: false,
                listingResponse: response
            };
        }
        case actions.FETCHING_FAILED_SETTINGS_CHALLENGE_TYPES: {
            return {
                ...state,
                listingFetching: false,
                listingError: response
            };
        }
        default:
            return state;
    }
};
